/**
 * @ub/shared/dates — канон НОЧНОГО СЛОТА сетки (не путать с ночным ОКНОМ
 * надбавки A24 из pricing.isNightTime — то про деньги, это про дату).
 *
 * Слоты раньше NIGHT_SLOT_END (00:xx…05:xx) бизнес-принадлежат СЛЕДУЮЩЕМУ
 * календарному дню: сетка дня D показывает их в хвосте, а бронь хранится
 * с date = D+1 (create-семантика useBookings.save; с A48 тем же живёт и
 * PUT /bookings/move). Единственный источник границы — эта константа.
 *
 * Только чистые функции без зависимостей — файл, как pricing.ts, пригоден
 * для прямого исполнения node'ом через type stripping.
 */

/** Граница ночного хвоста сетки: время СТРОГО раньше — слот следующего дня. */
export const NIGHT_SLOT_END = "06:00";

/** "00:00"…"05:59" — ночной слот, бизнес-принадлежит следующему дню. */
export function isNightSlot(time: string): boolean {
  return time < NIGHT_SLOT_END;
}

/**
 * ISO-дата "YYYY-MM-DD" ± n дней. Чистая UTC-арифметика: Date.UTC переносит
 * месяцы/годы сам, локальная TZ не участвует (в UTC+5 local-полночь дала бы
 * сдвиг на день назад — см. utils/date.todayBusiness в apps/web).
 */
export function addDaysIso(date: string, days: number): string {
  const [y, m, d] = date.split("-").map(Number);
  return new Date(Date.UTC(y ?? 1970, (m ?? 1) - 1, (d ?? 1) + days))
    .toISOString()
    .slice(0, 10);
}
